/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCompareParts = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 22H2v-4h6zm14 0h-6v-8h6zM8 17H2v-6h6zm-4-2h2v-2H4zm18-2h-6V2h6zm-4-2h2V4h-2zm-3-7h-2v5h2v2H9V9h2V4H9V2h6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCompareParts as CompareParts };
